import { Component, OnInit, Input } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

import {
  ApiRequestService,
  InteractService,
} from 'app'
import { json } from 'ngx-custom-validators/src/app/json/validator';
@Component({
  selector: 'app-ui-accordion-small',
  templateUrl: './ui-accordion-small.component.html',
  styleUrls: ['./ui-accordion-small.component.scss']
})
export class UiAccordionSmallComponent implements OnInit {

  exclusionsList = [];
  termsAndConditionsList = [];
  @Input() title: any;
  @Input() toggleFor: any;
  @Input() set IO(value: any) {
    console.log("policy data", value)
    this.selectedpolicy = value;
    console.log("selectedpolicy 1", this.selectedpolicy);
  }

  @Input() dataList(dataList: any) {
    if (Array.isArray(dataList) && dataList.length > 0) {
      this.exclusionsList = dataList[0] ? dataList[0].productLoadingExclusionList : [];
      this.termsAndConditionsList = dataList[0] ? dataList[0].productTermAndConditionList : [];
    }
  }

  isToggledOpen = false;
  isTermsConditionsToggleOpen = false;
  constructor(private message: NzMessageService,
    private apiRequestService: ApiRequestService,
    private interactService: InteractService, ) { }

  genericSubject$;
  ngOnInit() {
    // this.fetchSelectedPolicy();
    if (this.genericSubject$ != null)
      this.genericSubject$.unsubscribe();

    this.genericSubject$ = this.interactService.genericDataSubject$.subscribe(value => {
      if (Array.isArray(value) && value.length > 0) {
        this.exclusionsList =  value[0] ? value[0].productLoadingExclusionList: [];
        this.termsAndConditionsList = value[0] ? value[0].productTermAndConditionList: [];
      }
    })
  }

  searchURL = "fetchProductTermConditions"
  termModal: boolean = false;
  termConditionData: any;
  toggle() {
    this.isToggledOpen = true;
  }


  closetoggle() {
    this.isToggledOpen = false
  }

  toggleTandC() {
    this.termModal = !!status
    console.log("selectedpolicy 2", this.selectedpolicy);
    if (this.selectedpolicy && this.selectedpolicy.caseDO && this.selectedpolicy.caseDO.baseProductCd) {
      let pathVariables = [];
      pathVariables.push(this.selectedpolicy.caseDO.baseProductCd);
      this.apiRequestService.getCallWithAPIMapper(this.searchURL, null, null, pathVariables).subscribe(data => {
        if (data) {
          this.termConditionData = data;
          this.isTermsConditionsToggleOpen = true;
          this.isToggledOpen = false;
        }
        else {
          this.message.error('Data not found', { nzDuration: 3000 });
          this.isTermsConditionsToggleOpen = false;
          this.termConditionData = null;
        }
      });
    } else {
      this.message.error('Data not found', { nzDuration: 3000 });
      this.isTermsConditionsToggleOpen = false;
      this.termConditionData = null;
    }
  }


  closetoggleTandC() {
    this.isTermsConditionsToggleOpen = false
  }


  selectedpolicy;
  tandCPolicySubject$ = null;
  fetchSelectedPolicy() {
    if (this.tandCPolicySubject$) this.tandCPolicySubject$.unsubscribe()
    this.tandCPolicySubject$ = this.interactService.tandCPolicySubject$.subscribe(res => {
      this.selectedpolicy = res;
    });
  }

}
